import React from "react";

import ClayTable from "@clayui/table";
import OrderTableRow from "./OrderTableRow";
import {useTranslation} from "react-i18next";

const OrdersTable = ({orders, deleteAction, setCurrentCart, setExpand}) => {
    const { t } = useTranslation();

    return (
        <ClayTable borderless className="orders-table">
            <ClayTable.Head>
                <ClayTable.Row>
                    <ClayTable.Cell headingCell>
                        ID
                    </ClayTable.Cell>

                    <ClayTable.Cell headingCell>
                        {t('name')}
                    </ClayTable.Cell>

                    <ClayTable.Cell headingCell>
                        {t('last-modified')}
                    </ClayTable.Cell>

                    <ClayTable.Cell headingCell>
                        &nbsp;
                    </ClayTable.Cell>
                </ClayTable.Row>
            </ClayTable.Head>

            <ClayTable.Body>
                {orders.map((order) => (
                    <OrderTableRow setExpand={setExpand} setCurrentCart={setCurrentCart} key={order.id} order={order} deleteAction={deleteAction}/>
                ))}
            </ClayTable.Body>
        </ClayTable>
    );
}

export default OrdersTable;